import { ROLE } from 'static';
import { InviteGuestLabel, optionsProps, PaginationType } from 'types';
import { cookieDecryption } from 'utils';
import { PrePopulatedInvitee } from 'utils/eventGuestPayload';
import { EMPTY_PAIR_GUEST_FILTERS, PairGuestFilters } from 'utils/pairGuestFilters';
import { EMPTY_SINGLE_ROLE_GUEST_FILTERS, SingleRoleGuestFilters } from 'utils/singleRoleGuestFilters';
import { create } from 'zustand';

interface Sort {
  headerType: string;
  sortType: string;
}
export interface SOMType {
  label: string;
  value: string;
  min: number;
  max: number;
}
interface ApproveEventsData {
  eventId: string;
  flag: number;
}
interface AttachmentUpload {
  key: string;
  localtion: string;
  // Saved with the event as `attachmentMeta`.
  filename?: string;
  type?: string;
  uploadedAt?: string;
}
export interface InviteToNewEventContext {
  sourceEventId: string;
  guestLabel: InviteGuestLabel;
  guestSelection: any[];
  inviteSelection: {
    selectedCount: number;
    pairIds: string[];
    userIds: string[];
    inviteeFirstNames: string[];
  };
  invitees: PrePopulatedInvitee[];
  isReturning: boolean;
}
interface useEventsStore {
  tab: string;
  search: string;
  eventDetailsData: any | null;
  pagination: PaginationType;
  sort: Sort;
  guestShort: any;
  fileData: any;
  initialEventsResponse: Object[];
  setState(nextState: Partial<useEventsStore>): void;
  approveEvents: ApproveEventsData | null;
  isRejectedView: boolean;
  attachmentResponse: AttachmentUpload | null;
  guestListArray: any;
  guestList: any;
  seletedGuestList: any;
  calenderDate: any;
  createEventsData: any;
  editedData: any;
  contiune: boolean | null;
  isDelete: boolean | null;
  eventId: null | string;
  addGuest: boolean;
  eventsForFullCalendar: any;
  popUpData: any;
  btnLoader: boolean;
  dateArrayAllEvents: any;
  attachmnetUpload: boolean;
  attendancePayload: any;
  invitationPayload: any;
  guestSearch: any;
  guestData: any;
  addEvent: any;
  guestPayLoad: any;
  guestListLoader: any;
  displayGuestList: any;
  filterModal: boolean;
  filterModalGuest: boolean;
  isDisable: boolean;
  filterOptions: any;
  groupFilterValue: any;
  eventTypeFilterValue: any;
  institutionFilterOptions: any;
  institutionFilterValue: any;
  createdByAdminFilterOptions: any;
  createdByAdminFilterValue: any;
  attendanceType: optionsProps;
  invitationType: optionsProps;
  pairGuestFilters: PairGuestFilters;
  singleRoleGuestFilters: SingleRoleGuestFilters;
  eventDetailPageCouts: any;
  eventAttendanceResId: string;
  invitationResId: string;
  isAttendanceMode: boolean;
  isAttendanceFinalized: boolean;
  isEditingAttendance: boolean;
  // Attendee-table bulk selection. Entries carry a synthetic `_id` because pair rows have no id
  // of their own — see guestSelectionId in EventDetail.
  guestSelection: any[];
  guestSelectAll: boolean;
  // Set by the Invite modal's Create New Event so the new event starts with the selection as
  // guests, and so its Back link can reopen the modal on the event it came from.
  inviteToNewEvent: InviteToNewEventContext | null;
  setGuestSearch(search: string): void;
  setSearch(search: string): void;
}
const { I_SUPER_ADMIN } = ROLE;
const user = cookieDecryption('user');
const useEvents = create<useEventsStore>(set => ({
  tab: user?.role === I_SUPER_ADMIN ? 'All Events' : 'My Events',
  setSearch: (search: string) => set({ search }),
  setGuestSearch: (search: string) => set({ search }),
  guestListArray: null,
  search: '',
  sort: {
    headerType: '',
    sortType: '',
  },
  guestShort: {
    headerType: '',
    sortType: '',
  },
  addGuest: false,
  approveEvents: null,
  eventsForFullCalendar: null,
  createEventsData: null,
  isRejectedView: false,
  attachmentResponse: null,
  calenderDate: null,
  dateArrayAllEvents: null,
  eventDetailsData: null,
  filterModalGuest: false,
  isDisable: false,
  guestList: null,
  seletedGuestList: null,
  fileData: null,
  editedData: null,
  isDelete: null,
  eventId: null,
  contiune: null,
  popUpData: null,
  btnLoader: false,
  addEvent: false,
  attachmnetUpload: false,
  attendancePayload: null,
  invitationPayload: null,
  displayGuestList: null,
  guestPayLoad: null,
  guestSearch: null,
  guestData: null,
  guestListLoader: '',
  attendanceType: { label: '', value: '' },
  invitationType: { label: '', value: '' },
  pairGuestFilters: EMPTY_PAIR_GUEST_FILTERS,
  singleRoleGuestFilters: EMPTY_SINGLE_ROLE_GUEST_FILTERS,
  guestSelection: [],
  guestSelectAll: false,
  inviteToNewEvent: null,
  eventDetailPageCouts: {
    RSVPYes: null,
    RSVPNo: null,
    noResponse: null,
    totalInvites: null,
    attendedCount: null,
    pairsInvited: null,
    pairsAttended: null,
  },
  pagination: {
    limit: 25,
    page: 1,
    pages: 0,
    total: -1,
  },
  eventAttendanceResId: '',
  invitationResId: '',
  isAttendanceMode: false,
  isAttendanceFinalized: false,
  isEditingAttendance: false,
  filterModal: false,
  filterOptions: [],
  groupFilterValue: [],
  eventTypeFilterValue: [],
  institutionFilterOptions: [],
  institutionFilterValue: [],
  createdByAdminFilterOptions: [],
  createdByAdminFilterValue: [],
  initialEventsResponse: [],
  setState: nextState => set(() => ({ ...nextState })),
}));

export default useEvents;
